/* Mantém a referência do Keycloak criada em TenantApp */
let currentKC = null;
export const setKeycloak = (kc) => { currentKC = kc; };
export const getKeycloak = () => currentKC;
